import React from 'react'
import { User } from '../../../api/users'
import Modal, { ModalActions } from '../../modal'
import { Element } from 'react-bulma-components'
import UserQrCode from '../user-qr-code'

interface UserQrCodeModalProps {
  user: User
  modalActions: ModalActions
  canRegenerate?: boolean
  isExternalWorker?: boolean
}

const UserQrCodeModal: React.FC<UserQrCodeModalProps> = ({
  user,
  modalActions,
  canRegenerate = true,
  isExternalWorker = false,
}) => {
  return (
    <Modal title={`QR Code de  ${user?.firstName} ${user?.lastName}`} actions={modalActions}>
      <Element textAlign="center">
        {user?._id && (
          <UserQrCode
            user={user}
            print
            canRegenerate={canRegenerate}
            isExternalWorker={isExternalWorker}
          />
        )}
      </Element>
    </Modal>
  )
}

export default UserQrCodeModal
